'use client';
import { OnbForm } from '@/components/form';
import { useStepData } from '@/components/stepData';
import { pushStepVariables } from '@/redux/flowSlice';
import { pushLyraToken } from '@/redux/navigationSlice';
import { RootState } from '@/redux/store';
import { Button, Typography } from '@mui/material';
import { paymentMethod } from '@repo/onb-api';
import { MaterialIcon, PaymentSelection } from '@repo/ui';
import { useRouter } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';
import StepWrapper from './stepWrapper';

export default function PaymentMethodLyra({
  stepname: stepName,
  stepdata: stepDataProp,
}: {
  stepname?: paymentMethod['name'];
  stepdata?: paymentMethod['variables'];
}): React.JSX.Element {
  const stepData = useStepData(stepDataProp);
  //@todo this logic should be in the button component
  const dispatch = useDispatch();
  const router = useRouter();
  const policyProduct = useSelector((state: RootState) => state.additionalData.policyProduct);
  const handleSubmit = ({ paymentMethod, cardId }: paymentMethod['variables']) => {
    if (stepName) {
      dispatch(pushStepVariables({ stepName, variable: 'paymentMethod', value: paymentMethod }));
      if (cardId) dispatch(pushStepVariables({ stepName, variable: 'cardId', value: cardId }));
    }
  };
  const formToken = stepData?.paymentMethods?.find((method) => method.formToken)?.formToken;
  const debitCardIndex = stepData?.paymentMethods?.findIndex(({ name }) => name === 'DEBIT_CARD') || 0;
  const orderedPaymentMethods = stepData?.paymentMethods
    ?.slice(debitCardIndex)
    .concat(stepData?.paymentMethods?.slice(0, debitCardIndex));
  return (
    <StepWrapper>
      <Typography variant="h1">
        {process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-efectivo' || policyProduct === 'EFECTIVOC'
          ? '¿Cómo querés pagar tu préstamo?'
          : '¿Cómo querés pagar tu compra?'}
      </Typography>
      <OnbForm<paymentMethod> stepName={stepName!} hideSubmit>
        {orderedPaymentMethods?.map(({ name, cards }) => {
          if (name === 'DEBIT_CARD') {
            return cards?.map(({ id, number, issuer, type }) => (
              <PaymentSelection
                key={`card-${id}`}
                data-testid={`card-${id}`}
                gateway="card"
                title={type === 'CREDIT' ? 'Crédito' : 'Débito'}
                issuer={issuer}
                cardNumber={number}
                onClick={() => handleSubmit({ paymentMethod: 'DEBIT_CARD', cardId: id })}
              />
            ));
          }

          if (name === 'CASH') {
            return (
              <PaymentSelection
                data-testid="cash"
                key={'cash'}
                gateway="cash"
                title="En locales habilitados o Pago Digital"
                description="Con tu DNI o Cuponera en RapiPago, Pago Fácil, Mercado Pago, Plus Pagos, Pago Mis Cuentas, Pagos Link, Bapro Pagos y Cobro Express."
                onClick={() => handleSubmit({ paymentMethod: 'CASH' })}
              />
            );
          }
        })}
        {/* Text action under the options, as in customer-mobile */}
        {formToken && (
          <Button
            variant="text"
            data-testid="card"
            startIcon={<MaterialIcon icon="add" />}
            sx={{ alignSelf: 'center' }}
            onClick={(e) => {
              e.preventDefault();
              dispatch(pushLyraToken(formToken));
              router.push('/lyra');
            }}
          >
            Agregar tarjeta
          </Button>
        )}
      </OnbForm>
    </StepWrapper>
  );
}
